import { useGetUsersSelfQuery } from "api/baseAPI/user";

export function getTimezone() {
  const getUsersSelfQuery = useGetUsersSelfQuery();
  const timezone: string = getUsersSelfQuery?.data?.timezone || "Europe/Kiev";

  return timezone;
}
